
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductBank } from '@/api/product/product'
import { getBnakList } from '@/api/universal'
import loginLogVue from '@/views/merchant/components/loginLog/loginLog.vue'
@Component({
  name: 'editProductBank',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private productId!: any
  @Prop({ required: true }) private product!: any
  private centerDrawerVisible: boolean = false
  private bankList: any[] = []

  private container: any = {
    status: null,
    priority: null,
    id: null
  }

  private infoForm: any = {
    account_type: ''
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 筛选
  private select () {
    let data: any = {
      account_type: this.infoForm.account_type
    }
    this.getBankList()
  }

  // 获取产品银行列表
  private async getBankList () {
    await getBnakList({ id: this.productId, distinct: 0 }).then((res: any) => {
      this.bankList = res
    })
  }

  private openDialogVisible (row) {
    this.centerDrawerVisible = true
    this.container = JSON.parse(JSON.stringify(row))
  }

  // 列表状态更改
  private async setStatus (row: any) {
    const status = row.status === 0 ? 1 : 0
    const data: any = {
      productId: this.productId,
      priority: row.priority,
      id: row.id,
      status: row.status
    }
    try {
      await setProductBank(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
      })
    } catch (e) {
      row.status = status
    }
  }

  // 产品银行编辑
  private async update () {
    this.flag = true
    const data: any = {
      productId: this.productId,
      status: this.container.status,
      priority: this.container.priority,
      id: this.container.id,
      ...this.infoForm
    }
    try {
      await setProductBank(data).then(async (res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        await this.getBankList()
        this.centerDrawerVisible = false
        this.flagStr()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  mounted () {
    this.getBankList()
  }
}
